/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import React, { ReactElement } from 'react';
import { Container, Grid, Typography } from '@material-ui/core';
import CreateCourseView from './CreateCourse/CreateCourseView';
import CourseView from './Course/CoursesView';
import CoursesOverviewStyles from './CoursesOverviewViewStyles';
import { FormattedMessage } from 'react-intl';
import { useViewModel } from '../../../hooks/useViewModel';
import { CoursesOverviewViewModel } from './CoursesOverviewViewModel';
import { observer } from 'mobx-react';
import { autorun } from 'mobx';
import { Course } from '../../../types/course/Course';

const CoursesOverviewView = observer((): ReactElement => {
	const classes = CoursesOverviewStyles();
	const viewModel: CoursesOverviewViewModel = useViewModel(CoursesOverviewViewModel);

	autorun(() => {
		viewModel.subscribeToCourseEvents().forEach(() => {
			viewModel.queryCourses();
		});
	});

	return (
		<Container className={classes.root}>
			<Typography variant={'h1'}>
				<FormattedMessage id='courses.title' />
			</Typography>
			<Grid className={classes.gridContainer} container spacing={2}>
				<Grid item md={2} sm={4} xs={6}>
					<CreateCourseView />
				</Grid>
				{viewModel.getCourses().map((course: Course) => {
					return (
						<Grid key={course.courseId} item md={2} sm={4} xs={6}>
							<CourseView course={course} />
						</Grid>
					);
				})}
			</Grid>
		</Container>
	);
});

export default CoursesOverviewView;
